module.exports = __webpack_public_path__ + "img/slice2.5481e785.jpg";